import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <>
    <path fillOpacity=".3" d="M2 22h20V2z"></path>
    <path d="M8 16.5L2 22h6z"></path>
  </>,
  "SignalCellular1Bar"
);
